import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";

import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, memoActionDel } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { ServerRequest } from '../../utils/apiweb';
import { VALIDATION_MESSAGE } from '../../consts/validationMessage';
import { useNav, useReporte, useFormErrors } from '../../components/hooks';
import { Loading, SectionHeading, InputCuenta, InputStaticEntidad, InputNumber, DatePickerCustom, FormLabel, FormError } from '../../components/common';
import ConfirmacionReciboModal from '../../components/controls/ConfirmacionReciboModal';
import { getDateNow } from '../../utils/convert';
import { OpenObjectURL } from '../../utils/helpers';


function PagoContadoView() {

    //parametros url
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNav()

    const toDay = getDateNow(false);

    const {cache} = useSelector( (state) => state.memo );

    const entityInit = {
        cuenta: {
            id: 0,
            numeroCuenta: '',
            numeroWeb: '',
            idEstadoCuenta: 0,
            idTipoTributo: 0,
            idTributo: 0,
            fechaAlta: null,
            fechaBaja: null,
            idContribuyentePrincipal: 0,
            idDireccionPrincipal: 0,
            idDireccionEntrega: 0
        },
        pagoContadoDefinicion: {
            id: 0,
            idEstadoPagoContadoDefinicion: 0,
            idTipoPlanPago: 0,
            idTipoTributo: 0,
            idTasaPagoContado: 0,
            idSubTasaPagoContado: 0,
            codigo: "",
            descripcion: "",
            fechaDesde: null,
            fechaHasta: null,
            idTipoAlcanceTemporal: 0,
            fechaDesdeAlcanceTemporal: null,
            fechaHastaAlcanceTemporal: null,
            mesDesdeAlcanceTemporal: 0,
            mesHastaAlcanceTemporal: 0,
            aplicaDerechosEspontaneos: false,
            aplicaTotalidadDeudaAdministrativa: false,
            aplicaDeudaAdministrativa: false,
            aplicaDeudaLegal: false,
            aplicaGranContribuyente: false,
            aplicaPequenioContribuyente: false,
            montoDeudaAdministrativaDesde: 0,
            montoDeudaAdministrativaHasta: 0,
            idViaConsolidacion: 0,
            porcentajeQuitaRecargos: 0,
            porcentajeQuitaMultaInfracciones: 0,
            porcentajeQuitaHonorarios: 0,
            porcentajeQuitaAportes: 0,
            idUsuarioCreacion: 0,
            fechaCreacion: null,
            tipoPlanPago: {
                id: 0,
                codigo: '',
                nombre: '',
                idTipoTributo: 0,
                convenio: '',
                condiciones: '',
                firmas: ''
            }
        },
        opcionCuota: {
            numeroCuota: 0,
            cantidadCuotas: 0,
            importeCapital: 0,
            importeIntereses: 0,
            importeSellados: 0,
            importeAnticipo: 0,
            importeQuita: 0,
            importeCuota: 0,
            fechaVencimiento: null
        }
    };

    //hooks
    const [state, setState] = useState({
        idCuenta: 0,
        items: [],
        loading: false,
        disbled: false
    });
    const [cuenta, setCuenta] = useState(entityInit.cuenta);
    const [pagoContadoDefinicion, setPagoContadoDefinicion] = useState(entityInit.pagoContadoDefinicion);
    const [definiciones, setDefiniciones] = useState([]);
    const [opcionCuotaSelected, setOpcionCuotaSelected] = useState(entityInit.opcionCuota);
    const [messageConfirm, setMessageConfirm] = useState({
        show: false,
        title: "",
        data: null,
        callback: null
    });

    const reciboResumidoRef = useRef(false);

    const { errorOf, validate } = useFormErrors(getErrors);

    function getErrors() {
        const errors = {};

        if (pagoContadoDefinicion.id === 0) errors.pagoContadoDefinicion = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    useEffect(() => {
        const data = cache[params.processKey];
        if (data) { //el cache tiene datos
            setState(prevState => {
                return {...prevState, idCuenta: data.value.idCuenta, items: data.value.items};
            });
            SearchPagoContadoDefinicionCuenta(data.value.idCuenta, data.value.items);
        }
        else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, "No se pudo recuperar la información de la solicitud");
        }
    }, []);

    useEffect(() => {
        if (pagoContadoDefinicion.id > 0) {
            SearchPagoContadoDefinicionCuotas();
        }
        else {
            setOpcionCuotaSelected(entityInit.opcionCuota);
        }
    }, [pagoContadoDefinicion]);

    const [ generateReporte ] = useReporte({
        callback: (reporte, buffer, message, filename) => {
            if (buffer)
                OpenObjectURL(filename ?? `${reporte}.pdf`, buffer);
            else
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        }
    });

    //handles
    const handleClickVolver = () => {
        dispatch(memoActionDel(params.processKey));
        navigate({ to: "../deuda/edit/" + cuenta.id, });
    }
    const handleClickCrearPagoContado = () => {
        if (state.idCuenta === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "La cuenta no está definida");
            return;
        }
        if (!validate()) return;

        let data = {
            idCuenta: state.idCuenta,
            idPagoContadoDefinicion: pagoContadoDefinicion.id,
            items: state.items
        };
        setMessageConfirm({
            show: true,
            title: "Crear pago contado",
            data: data,
            callback: (data) => AddPagoContado(data)
        });
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setState(prevState => {
            return {...prevState, loading: false};
          });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
          return {...prevState, loading: false};
        });
    }
    const callbackSearchPagoContadoDefinicionCuenta = (response) => {
        response.json()
        .then((data) => {
            const definiciones = data.filter(f => f.valid);
            setDefiniciones(definiciones);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackSuccessSearchPagoContadoDefinicionCuotas = (response) => {
        response.json()
        .then((opcionCuotas) => {
            const opcionCuota = opcionCuotas[0];
            if (opcionCuota.fechaVencimiento) opcionCuota.fechaVencimiento = new Date(opcionCuota.fechaVencimiento);
            setOpcionCuotaSelected(opcionCuota);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackSuccessAddPagoContado = (response) => {
        response.json()
        .then((data) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Pago contado generado correctamente", () => {
                handleClickVolver();
            });
            setState(prevState => {
                return {...prevState, loading: false};
            });
            PrintRecibo(data.idCuentaPago);
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }

    //funciones
    function PrintRecibo(idCuentaPago) {
        const paramsReporte = {
            idCuentaPago: idCuentaPago,
            reciboResumido: reciboResumidoRef.current
        }
        generateReporte("CuentaCorrientePagoContado", paramsReporte);
    }
    function SearchPagoContadoDefinicionCuenta(idCuenta, items) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const dataBody = {
            items: items
        }
        const paramsUrl = `/cuenta/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.PAGO_CONTADO_DEFINICION,
            paramsUrl,
            dataBody,
            callbackSearchPagoContadoDefinicionCuenta,
            callbackNoSuccess,
            callbackError
        );

    }
    function SearchPagoContadoDefinicionCuotas() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const dataBody = {
            idCuenta: state.idCuenta,
            items: state.items
        }
        const paramsUrl = `/${pagoContadoDefinicion.id}/cuotas`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.PAGO_CONTADO_DEFINICION,
            paramsUrl,
            dataBody,
            callbackSuccessSearchPagoContadoDefinicionCuotas,
            callbackNoSuccess,
            callbackError
        );

    }
    function AddPagoContado(data) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const dataBody = data;

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.PAGO_CONTADO,
            null,
            dataBody,
            callbackSuccessAddPagoContado,
            callbackNoSuccess,
            callbackError
        );

    }
    
    return (
    <>

        <Loading visible={state.loading}></Loading>

        {messageConfirm.show && 
            <ConfirmacionReciboModal
                title={messageConfirm.title}
                message="Vas a crear el pago contado. ¿Querés continuar?"
                confirmLabel="Crear"
                onDismiss={() => {
                    setMessageConfirm({ show: false, title: "", data: null, callback: null });
                }}
                onConfirm={({ reciboResumido }) => {
                    reciboResumidoRef.current = reciboResumido;
                    if (messageConfirm.callback) {
                        messageConfirm.callback(messageConfirm.data);
                    }
                    setMessageConfirm({ show: false, title: "", data: null, callback: null });
                }}
            />
        }

        <SectionHeading
            titles={[
                { title: 'Tributos' },
                { title: 'Cálculo de deuda' },
                { title: 'Pago contado', },
            ]}
        />

        <section className='section-accordion'>
            <div className='row form-basic m-top-10 m-bottom-20'>
                <div className="col-12 col-lg-2">
                    <FormLabel htmlFor="cuenta" required>Cuenta</FormLabel>
                    <InputCuenta
                        name="cuenta"
                        placeholder=""
                        className="form-control"
                        value={state.idCuenta}
                        onUpdate={({target}) => {
                            const cuenta = target.row;
                            if (cuenta) {
                                setCuenta(cuenta);
                            }
                            else {
                                setCuenta(entityInit.cuenta);
                            }
                        }}
                        disabled={true}
                    />
                </div>
                <div className="col-12 col-lg-6">
                    <FormLabel htmlFor="pagoContadoDefinicion" required>Convenio</FormLabel>
                    <InputStaticEntidad
                        name="pagoContadoDefinicion"
                        placeholder=""
                        className={`form-control ${errorOf('pagoContadoDefinicion') ? 'is-invalid' : ''}`}
                        value={pagoContadoDefinicion.id}
                        title="Convenio"
                        onChange={({target}) => {
                            const definicion = target.row;
                            if (definicion) {
                                setPagoContadoDefinicion(definicion);
                            }
                            else {
                                setPagoContadoDefinicion(entityInit.pagoContadoDefinicion);
                            }
                        }}
                        onFormat={(row) => (row && row.id)
                                            ? (row.tipoPlanPago.convenio.length > 0)
                                                ? `${row.descripcion} (Convenio: ${row.tipoPlanPago.convenio})`
                                                : row.descripcion
                                            : ''}
                        columns={[
                            { Header: 'Código', accessor: 'codigo', width: '25%' },
                            { Header: 'Descripción', accessor: 'descripcion', width: '70%' }
                        ]}
                        list={definiciones}
                        disabled={state.disbled}
                    />
                    <FormError message={errorOf('pagoContadoDefinicion')} />
                </div>
            </div>

            {pagoContadoDefinicion.id > 0 &&
            <div className='row m-top-10 m-bottom-20'>
                <div className="col-12 col-lg-6">

                    <div className='row m-top-20'>
                        <div className="col-12 col-lg-4">
                            <label htmlFor="importeCapital" className="form-label">Deuda actualizada</label>
                            <InputNumber
                                name="importeCapital"
                                placeholder=""
                                className="form-control"
                                value={ opcionCuotaSelected.importeCapital }
                                precision={2}
                                disabled={true}
                            />
                        </div>
                    
                        <div className="col-12 col-lg-4">
                            <label htmlFor="importeQuita" className="form-label">(-) Total quita</label>
                            <InputNumber
                                name="importeQuita"
                                placeholder=""
                                className="form-control"
                                value={ opcionCuotaSelected.importeQuita }
                                precision={2}
                                disabled={true}
                            />
                        </div>
                        <div className="col-12 col-lg-4">
                            <label htmlFor="importeSellados" className="form-label">(+) Sellados</label>
                            <InputNumber
                                name="importeSellados"
                                placeholder=""
                                className="form-control"
                                value={ opcionCuotaSelected.importeSellados }
                                precision={2}
                                disabled={true}
                            />
                        </div>
                        <div className="col-12 col-lg-4">
                            <label htmlFor="importePlanPago" className="form-label">Monto de pago contado</label>
                            <InputNumber
                                name="importePlanPago"
                                placeholder=""
                                className="form-control"
                                value={ opcionCuotaSelected.importePlanPago }
                                precision={2}
                                disabled={true}
                            />
                        </div>
                        <div className="col-12 col-lg-4">
                            <label htmlFor="fechaVencimiento" className="form-label">Fecha de vencimiento</label>
                            <DatePickerCustom
                                name="fechaVencimiento"
                                placeholder=""
                                className="form-control"
                                value={ opcionCuotaSelected.fechaVencimiento }
                                disabled
                            />
                        </div>
                    </div>

                </div>

            </div>
            }
        </section>

        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <button className="btn back-button float-start" onClick={ (event) => handleClickVolver() }>Volver</button>
                {!state.disbled &&
                <button className="btn action-button float-end m-left-10" onClick={ (event) => handleClickCrearPagoContado() }>Crear pago contado</button>
                }
            </div>
        </footer>
        
    </>
    )
}

export default PagoContadoView;
